import { render, staticRenderFns } from "./StandardAPIHome.vue?vue&type=template&id=3d24c5b0&scoped=true&"
import script from "./StandardAPIHome.vue?vue&type=script&lang=js&"
export * from "./StandardAPIHome.vue?vue&type=script&lang=js&"
import style0 from "./StandardAPIHome.vue?vue&type=style&index=0&id=3d24c5b0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d24c5b0",
  null
  
)

export default component.exports